// src/img.tsx
import * as React from "react";
import { jsx } from "react/jsx-runtime";
var Img = React.forwardRef(
  ({ alt, src, width, height, style, ...props }, forwardedRef) => /* @__PURE__ */ jsx(
    "img",
    {
      ...props,
      ref: forwardedRef,
      "data-id": "react-email-img",
      alt,
      src,
      width,
      height,
      style: {
        display: "block",
        outline: "none",
        border: "none",
        textDecoration: "none",
        ...style
      }
    }
  )
);
Img.displayName = "Img";
export {
  Img
};
